import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Http, HttpModule, JsonpModule, BrowserXhr } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdInputModule, MdButtonModule, MaterialModule, MdDialogModule } from '@angular/material';

import { AppRoutingModule } from './routes/app.routing.module';
import { NoAuthRoutingModule } from './routes/no-auth.routing.module';

// Lazy Module
import { MasterDataModule } from './pages/master-data/master-data.module';
import { ChangePassModule } from './pages/change-password/change-password.module';
import { CreatePassModule } from './pages/create-password/create-password.module';
import { SharedModule } from './shared/shared.module';
import { CentreModule } from './pages/centre/centre.module';
import { ConsultationModule } from './pages/consultation/consultation.module';
import { ConsultationProcessModule } from './pages/consultation-process/consultation-process.module';
import { AdministrationModule } from './pages/administration/administration.module';
import { ConsultationHistoryModule } from './pages/consultation-history/consultation-history.module';
import { PaymentModule } from './pages/payment/payment.module';
import { BookingModule } from './pages/booking/booking.module';
import { ReportModule } from './pages/report/report.module';
import { SelectCentreModule } from './pages/select-centre/select-centre.module';

import { Utility } from './common/utility';
import { AuthHelper } from './common/auth.helper';
import { DocumentRef, WindowRef } from './common/refs';

// services
import { BaseService } from './shared/services/base.service';
import { PermissionService } from './shared/services/permission.service';
import { ValidationService } from './shared/services/validation.service';
import { DialogService } from './shared/services/dialog.service';
import { SpinnerService } from './components/spinner/spinner.service';


// components
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { LayoutComponent } from './components/layout/layout.component';
import { CardPageComponent } from './components/layout/card-page.component';
import { Error404Component } from './pages/error/404.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
//import { SelectCentreComponent } from './pages/select-centre/select-centre.component';
// import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { LandingComponent } from './pages/landing/landing.component';
import { AuthModule } from './pages/auth/auth.module';
import { AuthService } from './shared/services/auth.service';
import {PendingChangesGuard} from './pending-changes.guard';

// import { TypeaheadModule } from 'ngx-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DataEntryPopupComponent } from './components/header/data-entry-popup.component';
import { NewsComponent } from './pages/news/news.component';
import { TMBDataTableComponent } from './components/data-table/data-table.component';
import { PatientWarningComponent } from './components/dialog/patient-warning.component';
import { PatientDetailService } from './pages/consultation-process/patient-detail/patient-detail.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MenuComponent,
    DialogComponent,
    PatientWarningComponent,
    Error404Component,
    SpinnerComponent,
    LayoutComponent,
    //SelectCentreComponent,
    // ChangePasswordComponent,
    LandingComponent,
    CardPageComponent,
    DataEntryPopupComponent,
    NewsComponent,
    TMBDataTableComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpModule,
    JsonpModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MdDialogModule,
    NoAuthRoutingModule,
    AppRoutingModule,
    CentreModule,
    MasterDataModule,
    ConsultationModule,
    ChangePassModule,
    CreatePassModule,
    AdministrationModule,
    ConsultationHistoryModule,
    AuthModule,
    PaymentModule,
    ConsultationProcessModule,
    AuthModule,
    BookingModule,
    ReportModule,
    SelectCentreModule,
    InfiniteScrollModule
  ],
  providers:
  [
    Utility,
    AuthHelper,
    DocumentRef,
    WindowRef,
    BaseService,
    PermissionService,
    ValidationService,
    DialogService,
   
    SpinnerService,
    AuthService,
    PendingChangesGuard
  ],
  entryComponents: [DialogComponent, DataEntryPopupComponent,PatientWarningComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/app.module.ts